import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationEmptyStateRadar = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationEmptyStateRadar"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        fillOpacity={0.01}
        d="M31.17 66.93v-3.42A29.456 29.456 0 0 1 4.18 36.52H.76v-5h3.42a29.474 29.474 0 0 1 26.99-27V1.1h5v3.42l.65.06.53.07c.34.04.68.09 1.02.14l.58.1c.32.06.63.12.94.18l.54.12c.38.09.66.16.94.24.23.06.46.13.69.2.25.07.49.15.74.23.26.08.51.17.76.26.21.08.41.15.6.22.29.11.58.22.87.34.15.06.29.12.43.19.33.14.67.29 1 .46l.1.05c3.77 1.83 7.04 4.37 9.73 7.55l1.5 1.96c3.09 4.33 4.92 9.33 5.36 14.63h3.42v5h-3.42a29.456 29.456 0 0 1-26.99 26.99v3.42h-5z"
      />
      <path
        fill="#8A9DA6"
        d="M54.39 16.53C49.42 10.64 41.98 6.9 33.67 6.9v27.11z"
      />
      <path
        fill="#BCC9D1"
        d="M33.67 38.81a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6"
      />
      <path
        fill="#BCC9D1"
        d="M33.67 11.51c-12.43 0-22.5 10.07-22.5 22.5s10.07 22.5 22.5 22.5 22.5-10.07 22.5-22.5-10.07-22.5-22.5-22.5m0 41.68c-10.59 0-19.18-8.59-19.18-19.18s8.59-19.18 19.18-19.18 19.18 8.59 19.18 19.18-8.59 19.18-19.18 19.18"
      />
      <path
        fill="#BCC9D1"
        d="M33.67 19.98c-7.75 0-14.03 6.28-14.03 14.03s6.28 14.03 14.03 14.03S47.7 41.76 47.7 34.01s-6.28-14.03-14.03-14.03m0 24.71c-5.9 0-10.68-4.78-10.68-10.68s4.78-10.68 10.68-10.68 10.68 4.78 10.68 10.68-4.78 10.68-10.68 10.68"
      />
      <path
        fill="#5E737D"
        d="M61.27 33.51c-.11-6.4-2.41-12.27-6.19-16.91h.02l-.32-.39c-2.49-2.95-5.54-5.3-8.91-6.96-.08-.04-.16-.09-.25-.13-.18-.09-.36-.16-.54-.24-.27-.12-.53-.24-.8-.35-.11-.05-.22-.09-.33-.13-.35-.14-.7-.27-1.05-.4-.06-.02-.13-.04-.19-.07-.4-.14-.81-.27-1.22-.39-.03 0-.06-.02-.09-.03q-.66-.195-1.35-.36h-.02c-1.88-.44-3.84-.69-5.84-.73V3.1h-1v3.31C18.37 6.69 6.36 18.69 6.1 33.52H2.78v1H6.1c.27 14.82 12.27 26.83 27.09 27.09v3.32h1v-3.32c14.82-.27 26.83-12.27 27.09-27.09h3.32v-1h-3.32zm-28.1 27.1C18.9 60.34 7.34 48.79 7.08 34.52h3.6c.26 12.29 10.2 22.22 22.49 22.49zm0-4.61c-11.73-.26-21.22-9.75-21.49-21.49h2.34c.26 10.45 8.7 18.89 19.15 19.15zm0-3.33c-9.9-.26-17.89-8.25-18.15-18.15h4.15c.26 7.61 6.39 13.74 14 14zm0-5.15c-7.06-.26-12.75-5.94-13-13h2.35c.26 5.76 4.89 10.4 10.65 10.65zm0-3.35c-5.21-.26-9.4-4.44-9.65-9.65h4.91c.24 2.52 2.23 4.5 4.74 4.74zm0-9.08v3.17a4.27 4.27 0 0 1-3.74-3.74h3.74v.58zm0-1.58h-3.74a4.28 4.28 0 0 1 3.74-3.75zm0-4.74a5.26 5.26 0 0 0-4.74 4.75h-4.91c.25-5.21 4.44-9.4 9.65-9.65v4.91zm0-5.91c-5.76.26-10.4 4.89-10.65 10.65h-2.35c.26-7.06 5.94-12.75 13-13.01v2.36m0-3.35c-7.61.26-13.74 6.39-14 14.01h-4.15c.26-9.9 8.25-17.89 18.15-18.15v4.15zm0-5.15c-10.45.26-18.89 8.7-19.15 19.15h-2.34c.26-11.73 9.75-21.23 21.49-21.49zm0-3.34c-12.29.26-22.22 10.2-22.49 22.49h-3.6C7.35 19.24 18.9 7.68 33.17 7.42zm1-3.6c.13 0 .27 0 .4.01.25 0 .5.02.76.03.2.01.41.03.61.05.26.02.51.05.77.08.2.02.39.05.58.07.26.04.52.07.77.12.19.03.38.07.57.1l.75.15c.2.04.4.09.59.14l.69.18.64.18c.2.06.4.12.6.19.24.08.48.16.71.24.16.06.31.12.47.18.27.1.55.21.82.32.1.04.2.09.3.13.32.14.64.28.95.43.03.01.05.03.08.04a26.8 26.8 0 0 1 8.41 6.42l-2.75 2.32a22.97 22.97 0 0 0-16.74-7.79v-3.6zm3.09 24.23c.36.55.58 1.18.66 1.86h-2.87zm10.92 2.86h4.15c-.26 9.9-8.25 17.89-18.15 18.15v-4.15c7.61-.26 13.74-6.39 14.01-14zM34.17 47.52v-2.35c5.76-.26 10.4-4.89 10.65-10.65h2.35c-.26 7.06-5.94 12.75-13.01 13zm14.01-14.01a14.46 14.46 0 0 0-3.1-8.47l3.17-2.67c2.46 3.07 3.96 6.94 4.07 11.15h-4.15zm-1 0h-2.35c-.11-2.37-.95-4.55-2.31-6.31l1.8-1.52c1.71 2.18 2.75 4.88 2.86 7.83m-3.35 0h-4.91c-.09-.93-.39-1.79-.9-2.51l3.74-3.15c1.21 1.59 1.97 3.54 2.07 5.66m-4.91 1h4.91c-.26 5.21-4.44 9.4-9.65 9.65v-4.91c2.52-.24 4.5-2.23 4.74-4.74m-4.75 3.75v-3.74h3.74a4.27 4.27 0 0 1-3.74 3.74m0 15.41c10.45-.26 18.89-8.7 19.15-19.15h2.34c-.26 11.73-9.75 21.22-21.49 21.49zm19.16-20.16c-.11-4.45-1.7-8.54-4.31-11.79l1.78-1.5c2.95 3.65 4.75 8.27 4.86 13.29h-2.34zM34.17 12.02c6.35.14 12.05 2.99 15.98 7.43l-1.79 1.51c-3.5-3.94-8.55-6.46-14.19-6.6zm0 3.34c5.33.14 10.11 2.53 13.43 6.25l-3.17 2.67c-2.56-2.82-6.19-4.63-10.26-4.77zm0 5.15c3.76.14 7.12 1.81 9.5 4.42l-1.8 1.52c-1.94-2.1-4.66-3.45-7.7-3.58v-2.36m0 3.35c2.73.13 5.18 1.35 6.94 3.23l-3.74 3.15c-.84-.83-1.96-1.35-3.2-1.47zm0 5.91c.93.11 1.78.51 2.43 1.12l-2.43 2.05zm0 30.84v-3.6c12.29-.26 22.22-10.2 22.49-22.49h3.6c-.27 14.27-11.82 25.83-26.09 26.09m22.49-27.1c-.11-5.27-2-10.11-5.1-13.94l2.75-2.32a26.44 26.44 0 0 1 5.95 16.26z"
      />
    </svg>
  );
};
export default IllustrationEmptyStateRadar;
